module.exports = __webpack_public_path__ + "static/rahasia-saya-6aea5fd7eb6aa4959c483309be47815e.png";